import React from "react";

/** Renders guided-step body text with **bold** segments (shared by bar + common tasks list). */
export function renderFlowStepBody(text) {
  if (!text) return null;
  const segments = text.split(/(\*\*[^*]+\*\*)/g);
  return segments.map((seg, i) => {
    if (seg.startsWith("**") && seg.endsWith("**")) {
      return <strong key={`b-${i}`}>{seg.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={`t-${i}`}>{seg}</React.Fragment>;
  });
}
